class ErrorHandler {
    constructor(){
    }  
}

export default new ErrorHandler()